import './ShipperForm.scss';

import { Form, Input } from 'antd';
import { FormProps } from 'antd/lib';

interface ShipperFormProps {
  formProps: FormProps;
  edit?: boolean;
}

const ShipperForm = (props: ShipperFormProps) => {
  const { formProps, edit } = props;
  const { initialValues } = formProps;

  return (
    <Form {...formProps} layout="vertical" className="ShipperForm">
      {edit && initialValues?.id && (
        <div className="ShipperFormShowDataId">
          Id del operador: <span>{initialValues.id}</span>
        </div>
      )}
      <div className="ShipperFormDataContainer">
        <Form.Item
          label={'Nombre'}
          name={'name'}
          rules={[
            {
              required: true,
              message: 'El nombre es requerido',
            },
          ]}>
          <Input />
        </Form.Item>
        <Form.Item label={'Dirección'} name={'address'}>
          <Input />
        </Form.Item>
        <Form.Item label={'Teléfono'} name={'phone'}>
          <Input />
        </Form.Item>
        <Form.Item label={'Teléfono 2'} name={'phone2'}>
          <Input />
        </Form.Item>
        <Form.Item
          label={'Email'}
          name={'email'}
          rules={[{ type: 'email', message: 'Email inválido' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          label={'Link de tracking'}
          name={'tracking_link'}
          rules={[{ type: 'url', message: 'URL inválido' }]}>
          <Input />
        </Form.Item>
      </div>
    </Form>
  );
};

export default ShipperForm;
